// extracted by mini-css-extract-plugin
export default {"root":"Header_root__Paa1K","appbar":"Header_appbar__s16mH","toolbar":"Header_toolbar__Pd1Ul","title":"Header_title__Jrhbc","title_text":"Header_title_text__xHcQy"};